package com.milta.core.localization.translations.fr

import com.milta.core.localization.AdminUsersStrings

internal val AdminUsers = AdminUsersStrings(
    loading = "Chargement…",
    errorNoConnection = "Impossible de contacter le serveur — vérifie ta connexion.",
    errorGeneric = "Une erreur est survenue. Réessaie plus tard.",
    readOnlyNotice = "🔒 Consultation uniquement — aucune création, modification ou suspension de compte depuis cet écran pour l'instant.",
    kpiAccountsLabel = "Comptes",
    kpiAccountsSubtitle = "tous rôles confondus",
    kpiDriversLabel = "Chauffeurs",
    kpiDriversSubtitle = "sans équipe propre",
    kpiPatronsLabel = "Patrons",
    kpiPatronsOrgSingular = "organisation",
    kpiPatronsOrgPlural = "organisations",
    kpiActiveSubsLabel = "Abonnements actifs",
    kpiActiveSubsSubtitle = "actif + grâce",
    kpiAtRiskLabel = "À risque",
    kpiAtRiskSubtitle = "essai ou expiré",
    searchPlaceholder = "Rechercher un nom, un email, une organisation…",
    expandAllAction = "Tout déplier",
    collapseAllAction = "Tout replier",
    columnAccount = "Compte",
    columnContact = "Contact",
    columnType = "Type",
    columnAddedDate = "Ajouté / créée le",
    columnSubscription = "Abonnement",
    columnSince = "Depuis",
    columnRenewal = "Renouv.",
    noOrganizationHeader = "Sans organisation",
    emptySearchResult = "Aucun compte ne correspond à cette recherche.",
    patronBadgePrefix = "Patron",
    createdOnPrefix = "Créée le",
    emptyTeamMessage = "Aucun chauffeur dans cette équipe pour l'instant.",
    driverBadge = "Chauffeur",
    addedOnPrefix = "Ajouté le",
    viaOrganization = "Via organisation",
    accountCreatedOnUnknown = "Compte créé le —",
    renewalSingular = "renouvellement",
    renewalPlural = "renouvellements",
    subscriptionNone = "Aucun",
    subscriptionActive = "Actif",
    subscriptionTrial = "Essai",
    subscriptionGrace = "Grâce",
    subscriptionExpiredStatus = "Expiré",
    subscriptionCancelled = "Annulé",
    planOrganization = "Organisation",
    planDriver = "Chauffeur",
)
